import Vue from 'vue';
import Cookies from 'js-cookie'
import axios from './util/http';
import VueAxios from 'vue-axios';
import App from './App';
import i18n from './lang' // 国际化
import Element from 'element-ui'
import './permission'; // 权限
/* import './errorLog'; // 错误日志 */
import 'babel-polyfill'; // es6 转换es5
import router from './router/router';
import store from './store';
import {library} from '@fortawesome/fontawesome-svg-core'
import {fas} from '@fortawesome/free-solid-svg-icons'
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome'
import "./assets/iconfont/iconfont.css"
import './styles/common.scss';
import './components/index.js';
import './components/components.js';
import './assets/css/messagebox/messagebox.scss'
import basicContainer from './components/basic-container/main'
import './util/directives.js' //el-dialog拖拽功能的js
import './styles/theme/base.scss'
import './components/element-ui-cascader-multiple/style/cascader.css';

// // 确保 Vue.observable 可用 (Vue 2.7+ 兼容性修复)
// if (!Vue.observable) {
//   console.warn('Vue.observable not found, adding polyfill');
//   Vue.observable = function(obj) {
//     if (!obj || typeof obj !== 'object') {
//       return obj;
//     }
//     Vue.set(obj, '__ob__', new Observer());
//     return obj;
//   };
  
//   function Observer() {
//     this.dep = [];
//     this.vmCount = 0;
//   }
// }

// 引入 workflow-ui 样式
import WorkflowUI from '@cncec/workflow-ui2';
import '@cncec/workflow-ui2/dist/style.css';
Vue.use(WorkflowUI) 

Vue.use(Element, {
  size: Cookies.get('size') || 'medium', // !按需引入element-ui组件国际化
  // i18n: (key, value) => i18n.t(key, value) //暂时注释掉
})
Vue.use(VueAxios, axios)
//add font-awesome5
library.add(fas)
Vue.component('fa', FontAwesomeIcon)
Vue.component('basicContainer', basicContainer)
// process.env.NODE_ENV === 'development' &&
//   (() => {
//     document.cookie = `sag_token=${process.env.VUE_APP_SAG_TOKEN}; secure; samesite=strict; max-age=43200`
//     document.cookie = `sagserver_code=${process.env.VUE_APP_SAG_SERVER_CODE}; secure; samesite=strict; max-age=43200`
//   })()  
Vue.config.devtools = true;
Vue.config.productionTip = true;
function phone(){
  if((navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i))) {
    // console.log('移动端');
    return true;
  } else {
    // console.log('pc端');
    return false;
  }
}
function isWeiXin(){
  var ua = window.navigator.userAgent.toLowerCase();    // 该属性包含了浏览器类型、版本、操作系统类型、浏览器引擎类型等信息
  //通过正则表达式匹配ua中是否含有MicroMessenger字符串
  if(ua.match(/MicroMessenger/i) == 'micromessenger'){
    return true;
  }else{
    return false;
  }
}
export function createApp() {
  if(phone()||isWeiXin()){
    import ('./styles/mobile-cascader.scss')
  }
  const app = new Vue({
    router,
    store,
    i18n,
    render: h => h(App)
  })
  return {
    app,
    router,
    i18n,
    store
  }
}